import {initializeApp} from 'firebase/app';
import {getMessaging, Messaging} from 'firebase/messaging';

//TODO Change to production config
const firebaseConfig = {
    apiKey: 'AIzaSyB3sIH1piZ_SKdtU0746pvPr_cTPi8yTzw',
    authDomain: 'autosociaal-pwa.firebaseapp.com',
    projectId: 'autosociaal-pwa',
    storageBucket: 'autosociaal-pwa.appspot.com',
    messagingSenderId: '301726364766',
    appId: '1:301726364766:web:28c0d5737e50806abc70cf',
};

export const vapidKey = 'BI5svmSn_M89Oojp0AL9J6FFmToNI00KgKB5645qkBYw_bM7J58vXMWMOB-wBjbFBvmz7IMzOXmPaq-jCHXCar4';

const initializeMessaging = (): Messaging | undefined => {
    try {
        const app = initializeApp(firebaseConfig);
        return getMessaging(app);
    } catch (e) {
        console.error(e);
        return undefined;
    }
};

export const messaging = initializeMessaging();
